import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appInitials'
})
export class AppInitialsPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    let matches: string[];
    if (value && value.length > 1) {
      // matches capital letters
      matches = value.match(/[A-Z]/gm);
      if (!matches || matches.length < 2) {
        // matches first letter of each word
        matches = value.match(/\b(\w)/gm);
      }
      if (!matches || matches.length < 2) {
        matches = value.split('', 3);
      }
    }

    if (matches) {
      const res = matches.toString().replace(/,/g, '');
      return res.substr(0, res.length > 4 ? 4 : res.length);
    } else { return ''; }

  }
}
